import { useState } from "react";
import { clearToken, getToken } from "./api/client.js";
import { LoginGate } from "./components/LoginGate.js";
import { Dashboard } from "./components/Dashboard.js";

export function App() {
  const [authed, setAuthed] = useState<boolean>(() => getToken() !== null);

  if (!authed) {
    return <LoginGate onAuthenticated={() => setAuthed(true)} />;
  }

  return (
    <Dashboard
      onLogout={() => {
        clearToken();
        setAuthed(false);
      }}
    />
  );
}
